import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React__default, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import Text from '../components/text/text.component.js';
import img$1 from '../footer/images/disabled-arrow-light.svg.js';
import img from '../footer/images/disabled-arrow.svg.js';
import img$3 from '../footer/images/facebook-light.svg.js';
import img$2 from '../footer/images/facebook.svg.js';
import img$5 from '../footer/images/instagram-light.svg.js';
import img$4 from '../footer/images/instagram.svg.js';
import img$9 from '../footer/images/linkedin-light.svg.js';
import img$8 from '../footer/images/linkedin.svg.js';
import img$7 from '../footer/images/twitter-light.svg.js';
import img$6 from '../footer/images/twitter.svg.js';
import img$b from '../footer/images/youtube-light.svg.js';
import img$a from '../footer/images/youtube.svg.js';
import { parseColor, t } from '../utils/utils.js';
import Loader from '../loader/loader.component.js';
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var ContainerStyled = styled.div.withConfig({
  displayName: "join-communitycomponent__ContainerStyled",
  componentId: "sc-1den9m-0"
})(["margin:auto;padding-left:0px;padding-right:100px;padding-bottom:96px;box-sizing:border-box;max-width:100%;@media screen and (max-width:768px){padding-left:24px;padding-right:24px;padding-bottom:48px;}> div{flex-direction:row;}.img-social-hover:hover{filter:invert(0.2);}.social-community{display:flex;flex-direction:row;}.social-community > a{height:30px;margin-bottom:10px;margin-right:34px;cursor:pointer;text-decoration:none;}.social-community > a > img{margin-right:auto;width:100%;height:auto;object-fit:contain;}@media screen and (max-width:768px){.social-community{display:flex;flex-direction:row !important;justify-content:flex-start;margin-top:34px;}}@media screen and (min-width:1200px){> div{flex-direction:row;}}@media screen and (max-width:1200px){.social-community{margin-top:34px;}.social-community > a{width:24px;height:24px;margin-right:22px !important;cursor:pointer;}> div{flex-direction:column;}}"]);
var LeftContainer = styled.div.withConfig({
  displayName: "join-communitycomponent__LeftContainer",
  componentId: "sc-1den9m-1"
})(["max-width:550px;padding-right:55px;margin-top:56px;display:flex;flex-direction:column;justify-content:space-between;@media screen and (max-width:768px){padding-right:12px;margin-top:24px;}"]);
var RightContainer = styled.div.withConfig({
  displayName: "join-communitycomponent__RightContainer",
  componentId: "sc-1den9m-2"
})(["max-width:550px;padding-left:55px;margin-top:56px;display:flex;flex-direction:column;justify-content:space-between;@media screen and (max-width:1100px){padding-left:0px;margin-top:38px;}form{margin-top:60px;@media screen and (max-width:768px){margin-top:34px;}}"]);
var Input = styled.input.withConfig({
  displayName: "join-communitycomponent__Input",
  componentId: "sc-1den9m-3"
})(["height:56px;line-height:44px;width:100%;padding-left:20px;padding-right:120px;margin-right:0;outline:none;border:none;color:", ";background:transparent;font-family:EuclidCircularA-Medium,Arial;font-weight:500;font-size:16px;line-height:20px;border-radius:30px;cursor:pointer;&:focus{cursor:text;}::placeholder{color:", ";}@media screen and (max-width:768px){height:48px;margin-right:0px;width:100%;}"], function (props) {
  return props.theme == "dark" ? "white" : "var(--light-gray-9)";
}, function (props) {
  return props.theme == "dark" ? "var(--dark-gray-1)" : "var(--grey)";
});
var ContainerNewsletterButton = styled.div.withConfig({
  displayName: "join-communitycomponent__ContainerNewsletterButton",
  componentId: "sc-1den9m-4"
})(["position:relative;&::after{content:url(\"", "\");width:20px;height:20px;display:inline-block;position:absolute;top:18px;right:16px;filter:", ";}", ""], function (props) {
  var _props$theme;
  return ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.layout) == "dark" ? img : img$1;
}, function (props) {
  return props.emailValid ? "brightness(1000%)" : "";
}, function (props) {
  return props.emailValid ? "\n      &:hover {\n\n        ::after {\n\n          transition: 0.2s;\n          transform: translateX(4px);\n      \n        }\n\n        input {\n\n          background-color: var(--green-hover);\n\n        }\n\n      }\n    " : "";
});
var NewsletterButton = styled.input.withConfig({
  displayName: "join-communitycomponent__NewsletterButton",
  componentId: "sc-1den9m-5"
})(["-webkit-appearance:none;outline:none;cursor:pointer;padding:20px 40px 20px 16px;font-weight:600;border-radius:30px;height:56px;font-family:EuclidCircularA-Semibold,Arial;background:var(--green);color:var(--white);margin-top:0px !important;transition:0.3s;border:none;box-shadow:none;opacity:1;", " &:disabled{cursor:not-allowed;}@media screen and (max-width:768px){height:56px;}"], function (props) {
  return props.active ? "\n    &:hover{\n      background:var(--green-hover)!important;\n    }" : "";
});
var Container = styled.div.withConfig({
  displayName: "join-communitycomponent__Container",
  componentId: "sc-1den9m-6"
})(["width:100%;height:56px;max-width:462px;display:flex;align-items:center;justify-content:space-between;border-radius:30px;cursor:pointer;:hover{background-color:", " !important;}@media screen and (max-width:768px){width:100%;max-width:325px;}"], function (props) {
  return props.theme.layout == "dark" ? "var(--dark-gray-8)" : "var(--gray-base-7)";
});
var TextTitle = styled(Text).withConfig({
  displayName: "join-communitycomponent__TextTitle",
  componentId: "sc-1den9m-7"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:48px;line-height:57px;}"]);
var JoinCommunity = /*#__PURE__*/function (_Component) {
  _inherits(JoinCommunity, _Component);
  var _super = _createSuper(JoinCommunity);
  function JoinCommunity(props) {
    var _this;
    _classCallCheck(this, JoinCommunity);
    _this = _super.call(this, props);
    _this.state = {
      email: "",
      nameValid: false,
      loading: false,
      registered: false
    };
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.afterFormSubmitted = _this.afterFormSubmitted.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(JoinCommunity, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var name = event.target.name;
      var value = event.target.value; // setState receives a callback for when the state has finished updating

      this.checkValid(name, value);
    }
  }, {
    key: "afterFormSubmitted",
    value: function afterFormSubmitted(message) {
      this.props.handler(message);
    } // Check if the fields of the form are valid )
  }, {
    key: "checkValid",
    value: function checkValid(name, value) {
      var _this$setState;
      var emailValid = this.state.emailValid;
      emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) != null;
      this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, "emailValid", emailValid), _this$setState));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this2 = this;
      var lng = this.props.lng ? this.props.lng : "en";
      this.setState({
        loading: true
      });
      fetch("https://europe-west1-youngplatform.cloudfunctions.net/active-campaign-list-v2", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: this.state.email,
          product: this.props.product,
          lang: lng
        })
      }).then(function (response) {
        _this2.setState({
          email: "",
          emailValid: false,
          loading: false,
          registered: true
        });
      }).catch(function (error) {
        _this2.setState({
          loading: false
        });
        console.log(error);
      });
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        lng = _this$props.lng,
        product = _this$props.product;
      return /*#__PURE__*/React__default.createElement(ContainerStyled, null, /*#__PURE__*/React__default.createElement(TextTitle, {
        type: "display",
        fontFamily: "euclid",
        fontSize: "large",
        tag: "h2",
        style: {
          display: "block",
          maxWidth: "550px",
          marginBottom: "0px"
        }
      }, parseColor(t(lng, "join-community.title"), product === "step" ? "#ff298a" : "var(--green)")), /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React__default.createElement(LeftContainer, null, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "largeM",
        tag: "p",
        color: "grey-1",
        style: {
          display: "block",
          maxWidth: "465px"
        }
      }, t(lng, "join-community.telegram_caption")), /*#__PURE__*/React__default.createElement("div", {
        className: "social-community"
      }, /*#__PURE__*/React__default.createElement("a", {
        href: "https://www.facebook.com/youngplatformCME",
        title: "facebook",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-social-hover",
        alt: "facebook",
        src: theme.layout == "dark" ? img$2 : img$3
      })), /*#__PURE__*/React__default.createElement("a", {
        href: "https://www.instagram.com/young_platform/",
        title: "instagram",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-social-hover",
        alt: "instagram",
        src: theme.layout == "dark" ? img$4 : img$5
      })), /*#__PURE__*/React__default.createElement("a", {
        href: "https://twitter.com/youngplatform",
        title: "twitter",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-social-hover",
        alt: "twitter",
        src: theme.layout == "dark" ? img$6 : img$7
      })), /*#__PURE__*/React__default.createElement("a", {
        href: "https://www.linkedin.com/company/youngplatformcme/",
        title: "linkedin",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-social-hover",
        alt: "linkedin",
        src: theme.layout == "dark" ? img$8 : img$9
      })), /*#__PURE__*/React__default.createElement("a", {
        href: "https://www.youtube.com/channel/UCrkLdaIwZkeUbKRkzZCnNNg",
        title: "youtube",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-social-hover",
        alt: "youtube",
        style: {
          marginRight: "auto"
        },
        src: theme.layout == "dark" ? img$a : img$b
      })))), /*#__PURE__*/React__default.createElement(RightContainer, null, /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "largeM",
        tag: "p",
        color: "grey-1",
        style: {
          display: "block",
          maxWidth: "465px"
        }
      }, t(lng, "join-community.newsletter_caption")), /*#__PURE__*/React__default.createElement("form", {
        onSubmit: this.handleSubmit
      }, !this.state.registered && !this.state.loading ? /*#__PURE__*/React__default.createElement(Container, {
        style: {
          background: theme.layout == "dark" ? "var(--main)" : "#f4f5f7",
          position: "relative"
        }
      }, /*#__PURE__*/React__default.createElement(Input, {
        theme: theme,
        className: "input-newsletter",
        "aria-label": "newsletter",
        type: "text",
        name: "email",
        placeholder: t(lng, "join-community.newsletter_placeholder"),
        value: this.state.email,
        onChange: this.handleInputChange,
        required: "",
        style: {
          fontSize: "16px",
          lineHeight: "22px"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: "absolute",
          right: 0
        }
      }, /*#__PURE__*/React__default.createElement(ContainerNewsletterButton, {
        emailValid: this.state.emailValid,
        loading: "" + this.state.loading,
        theme: theme
      }, /*#__PURE__*/React__default.createElement(NewsletterButton, {
        theme: theme,
        style: {
          background: theme.layout == "dark" ? !this.state.emailValid || this.state.loading ? "var(--dark-gray-6)" : product === "step" ? "#ff298a" : "var(--green)" : !this.state.emailValid || this.state.loading ? "#DDDEE0" : product === "step" ? "#ff298a" : "var(--green)",
          color: theme.layout == "dark" ? !this.state.emailValid || this.state.loading ? "var(--dark-gray-2)" : "var(--white)" : !this.state.emailValid || this.state.loading ? "var(--gray-base-2)" : "var(--white)"
        },
        active: this.state.emailValid && !this.state.loading,
        disabled: !this.state.emailValid || this.state.loading,
        value: this.state.loading ? "loading" : t(lng, "join-community.newsletter_button"),
        type: "submit"
      })))) : this.state.loading ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React__default.createElement(Loader, {
        style: {
          margin: "auto",
          display: "block"
        }
      })) : /*#__PURE__*/React__default.createElement(Text, {
        fontFamily: "euclid",
        type: "paragraph",
        fontSize: "xxlarge",
        tag: "p",
        color: product === "step" ? "var(--pink)" : "var(--green)"
      }, t(lng, "join-community.newsletter_registered"))))));
    }
  }]);
  return JoinCommunity;
}(Component);
var joinCommunity_component = withTheme(JoinCommunity);
export { joinCommunity_component as default };